import "./ProfileScreen.css";
import { useEffect, useState } from "react";
import appIcon from "../../assets/images/header-app-icon.svg";
import profileLogoutIcon from "../../assets/images/profile-logout-icon.svg";
import LogoutDialog from "components/elements/LogoutDialog";
import { useLogout } from "services/LogoutProvider";

const ProfileScreen = () => {
  const { handleLogout } = useLogout();
  const [userProfileData, setUserProfileData] = useState<any>(null);
  const [showLogoutDialog, setShowLogoutDialog] = useState<boolean>(false);

  useEffect(() => {
    const storedData = localStorage.getItem("userProfileData");
    if (storedData) {
      const userData = JSON.parse(storedData);
      setUserProfileData(userData);
    }
  }, []);

  return (
    <div className="wms-mobile-container">
      <header className="profile-screen-header-header-bar">
        <div className="profile-screen-header-left-container">
          <img src={appIcon} alt="logo" />
        </div>
        <div className="profile-screen-header-divider"></div>
        <div className="profile-screen-header-right-container">
          Profile
          <img
            src={profileLogoutIcon}
            alt="logout-icon"
            onClick={() => setShowLogoutDialog(true)}
          />
        </div>
      </header>
      <div className="profile-screen-item-container">
        <span>
          First <span className="sub-text">Name</span>
        </span>
        <span className="item-text">{userProfileData?.first_name}</span>
        <div className="divider"></div>
      </div>
      <div className="profile-screen-item-container">
        <span>
          Last <span className="sub-text">Name</span>
        </span>
        <span className="item-text">{userProfileData?.last_name}</span>
        <div className="divider"></div>
      </div>
      <div className="profile-screen-item-container">
        <span>
          Email <span className="sub-text">Address</span>
        </span>
        <span className="item-text">{userProfileData?.email}</span>
        <div className="divider"></div>
      </div>
      <div className="profile-screen-item-container">
        <span>
          Mobile <span className="sub-text">Number</span>
        </span>
        <span className="item-text">{userProfileData?.mobile_number}</span>
        <div className="divider"></div>
      </div>
      <div className="profile-screen-item-container">
        <span>
          Admin <span className="sub-text">Position</span>
        </span>
        <span className="item-text">Admin</span>
        <div className="divider"></div>
      </div>
      <LogoutDialog
        open={showLogoutDialog}
        onClose={() => setShowLogoutDialog(false)}
        onYes={() => handleLogout()}
      />
    </div>
  );
};

export default ProfileScreen;
